import { useEffect, useState } from "react";
import { ScrollView, View, Text, Pressable } from "react-native";

import { ReactComponent as ArrowIco } from '../../../img/ico-prefix-arrow-up-blue.svg';
import { ReactComponent as CheckActive } from '../../../img/btn-checkbox-incon-circle-active.svg';
import { ReactComponent as CheckInactive } from '../../../img/btn-checkbox-incon-circle-inactive.svg';
import { deviceStatusCode, virtualMachineCode, deviceTypeCode } from "./NetworkTopologyData";
import { FONT } from "value/staticValues";
import { useTranslation } from "react-i18next";



const windowHeight = window.innerHeight;

// 전체 체크
function AllCheckBoxAndText({filter, list, setFilter}:{filter:string[], list:string[], setFilter:(filter:string[])=>void}) {
    const { t } = useTranslation();
    const connectStateAllCheck = filter.length === 0
    return (
        <View style={{flexDirection:"row", alignItems:"center", marginBottom:9}}>
            <Pressable
                onPress={()=>{
                    let newFilter;
                    if(connectStateAllCheck) {
                        newFilter = [...list]
                    }
                    else {
                        newFilter = []
                    }
                    setFilter(newFilter)
                }}>
            {
                connectStateAllCheck ? <CheckActive/> : <CheckInactive/>
            }
            </Pressable>
            <Text style={{color:"#333333", fontSize:13, fontFamily:FONT.REGULAR, marginLeft:10}}>{t("TOTAL_TEXT")}</Text>
        </View>
    )
}

// 아이템 체크
function CheckBoxAndText({text, convertText, list, setFilter}:{text:string, convertText:string, list:string[], setFilter:(filter:string[])=>void }) {
    const isChecked = !list.some((l)=>l===text)
    return (
        <View style={{flexDirection:"row", alignItems:"center", marginTop:5, marginBottom:5}}>
            <Pressable
                onPress={()=>{
                    let newFilter;
                    if(isChecked) {
                        newFilter = [...list]
                        newFilter.push(text);
                        
                    }
                    else {
                        newFilter = list.filter((l)=>l!==text)
                    }
                    setFilter(newFilter)
                }}>
            {
                isChecked ? <CheckActive/> : <CheckInactive/>
            }
            </Pressable>
            <Text style={{color:"#333333", fontSize:13, fontFamily:FONT.REGULAR, marginLeft:10}}>{convertText}</Text>
        </View>
    )
}




interface INetworkTopologyFilter {
    showText:boolean;
    setShowText:(check:boolean)=>void;
    showImportantText:boolean;
    setShowImportantText:(check:boolean)=>void;
    deviceStatusList:string[];
    filterDeviceStatus:string[];
    setFilterDeviceStatus:(filter:string[])=>void;
    groupList:string[];
    filterGroup:string[];
    setFilterGroup:(filter:string[])=>void;
    typeList:string[];
    filterType:string[];
    setFilterType:(filter:string[])=>void;
    dataCenterList:string[];
    filterDataCenter:string[];
    setFilterDataCenter:(dataCenter:string[])=>void;
}
export default function NetworkTopologyFilter(props:INetworkTopologyFilter) {
    const { t } = useTranslation();
    const [height, setHeight] = useState(0)
    const [showTextExpand, setShowTestExpand] = useState(true)  // 텍스트 표시 Expand
    const [deviceStatusExpand, setDeviceStatusExpand] = useState(true)  // 기기상태 Expand
    const [filterDeviceStatus, setFilterDeviceStatus] = useState<string[]>(props.filterDeviceStatus);  // 제외되는 항목
    const [groupExpand, setGroupExpand] = useState(true)  // 제조사 Expand
    const [filterGroup, setFilterGroup] = useState<string[]>(props.filterGroup); // 제외되는 항목
    const [typeExpand, setTypeExpand] = useState(true)  // 장비타입 Expand
    const [filterType, setFilterType] = useState<string[]>(props.filterType);   // 제외되는 항목
    const [dataCenterExpand, setDataCenterExpand] = useState(true)  // 데이터센터 Expand
    const [filterDataCenter, setFilterDataCenter] = useState<string[]>(props.filterDataCenter);   // 제외되는 항목

    useEffect(()=>{
        props.setFilterDeviceStatus(filterDeviceStatus)
    },[filterDeviceStatus])

    useEffect(()=>{
        props.setFilterGroup(filterGroup)
    },[filterGroup])

    useEffect(()=>{
        props.setFilterType(filterType)
    },[filterType])

    useEffect(()=>{
        props.setFilterDataCenter(filterDataCenter)
    },[filterDataCenter])

    useEffect(()=>{
        setHeight(getParentHeight()-60);
    },[])

    function getParentHeight() {
        const parent = document.getElementById('networkTopologyContent') as HTMLElement
        return parent.getBoundingClientRect().height;
    }
    
    return (
        <View style={{width:265, height, backgroundColor:"#ffffff", paddingTop:24, marginLeft:-30}}>
            <ScrollView style={{}}>
                <Text style={{color:"#252525", fontSize:16, fontFamily:FONT.BOLD, marginBottom:28}}>{t("FILTER_TEXT")}</Text>
                {/* 텍스트 표시 (Show Text) */}
                <Pressable style={{flexDirection:"row", alignItems:"center", marginBottom:10}} onPress={()=>setShowTestExpand(!showTextExpand)}>
                    <View style={{transform: [{ rotate: showTextExpand ? '0deg' : '180deg' }] }}><ArrowIco /></View>
                    <Text style={{color:"#333333", fontSize:14, fontFamily:FONT.MEDIUM, marginLeft:10}}>{t("RMS_TOPOLOGY_TEXT_DISPLAY_TEXT")}</Text>
                </Pressable>
                <View style={{width:220, backgroundColor:"#fafafa", padding:16, borderRadius:10}}>
                    {/* 노드텍스트 표시 */}
                    <View style={{flexDirection:"row", alignItems:"center", marginBottom:5}}>
                        <Pressable
                            onPress={()=>props.setShowText(!props.showText)}>
                        {
                            props.showText ? <CheckActive/> : <CheckInactive/>
                        }
                        </Pressable>
                        <Text style={{color:"#333333", fontSize:13, fontFamily:FONT.REGULAR, marginLeft:10}}>{t("RMS_TOPOLOGY_SHOW_TEXT")}</Text>
                    </View>
                    {/* 핵심 노드텍스트 표시 */}
                    <View style={{flexDirection:"row", alignItems:"center", marginBottom:5}}>
                        <Pressable
                            onPress={()=>props.setShowImportantText(!props.showImportantText)}>
                        {
                            props.showImportantText ? <CheckActive/> : <CheckInactive/>
                        }
                        </Pressable>
                        <Text style={{color:"#333333", fontSize:13, fontFamily:FONT.REGULAR, marginLeft:10}}>{t("RMS_TOPOLOGY_IMPORTANT_SHOW_TEXT")}</Text>
                    </View>
                </View>

                {/* 기기 상태 (statusCode) */}
                <Pressable style={{flexDirection:"row", alignItems:"center", marginBottom:10, marginTop:24}} onPress={()=>setDeviceStatusExpand(!deviceStatusExpand)}>
                    <View style={{transform: [{ rotate: deviceStatusExpand ? '0deg' : '180deg' }] }}><ArrowIco /></View>
                    <Text style={{color:"#333333", fontSize:14, fontFamily:FONT.MEDIUM, marginLeft:10}}>{t("RMS_DEVICES_STATE")}</Text>
                </Pressable>
                {deviceStatusExpand && <View style={{width:220, backgroundColor:"#fafafa", padding:16, borderRadius:10}}>
                    <AllCheckBoxAndText filter={filterDeviceStatus} list={props.deviceStatusList} setFilter={setFilterDeviceStatus}/>
                    <View style={{backgroundColor:"#eceeef", height:1, marginBottom:5}}/>
                    <View style={{paddingLeft:20}}>
                    {
                        props.deviceStatusList.map((text)=>{
                            const convert = deviceStatusCode.filter(c=>c.key === text)[0];
                            return convert ? <CheckBoxAndText key={text} text={text} convertText={convert.value} list={filterDeviceStatus} setFilter={setFilterDeviceStatus}/> : null
                        })
                    }
                    </View>
                </View>}

                {/* 외부 내트워크 연결 (Type) */}
                <Pressable style={{flexDirection:"row", alignItems:"center", marginBottom:10, marginTop:24}} onPress={()=>setTypeExpand(!typeExpand)}>
                    <View style={{transform: [{ rotate: typeExpand ? '0deg' : '180deg' }] }}><ArrowIco /></View>
                    <Text style={{color:"#333333", fontSize:14, fontFamily:FONT.MEDIUM, marginLeft:10}}>{t("RMS_DEVICES_NETWORK_TYPE")}</Text>
                </Pressable>
                {typeExpand && <View style={{width:220, backgroundColor:"#fafafa", padding:16, borderRadius:10}}>
                    <AllCheckBoxAndText filter={filterType} list={props.typeList} setFilter={setFilterType}/>
                    <View style={{backgroundColor:"#eceeef", height:1, marginBottom:5}}/>
                    <View style={{paddingLeft:20}}>
                    {
                        props.typeList.map((text)=>{
                            const convert = deviceTypeCode.filter(c=>c.key === text)[0];
                            return convert ? <CheckBoxAndText key={text} text={text} convertText={convert.value} list={filterType} setFilter={setFilterType}/> : null
                        })
                    }
                    </View>
                </View>}

                {/* 장비타입 (Type) */}
                {/* <Pressable style={{flexDirection:"row", alignItems:"center", marginBottom:10, marginTop:24}} onPress={()=>setTypeExpand(!typeExpand)}>
                    <View style={{transform: [{ rotate: typeExpand ? '0deg' : '180deg' }] }}><ArrowIco /></View>
                    <Text style={{color:"#333333", fontSize:14, fontFamily:FONT.MEDIUM, marginLeft:10}}>{t("RMS_DEVICES_NETWORK_TYPE")}</Text>
                </Pressable>
                {typeExpand && <View style={{width:220, backgroundColor:"#fafafa", padding:16, borderRadius:10}}>
                    <AllCheckBoxAndText filter={filterType} list={props.typeList} setFilter={setFilterType}/>
                    <View style={{backgroundColor:"#eceeef", height:1, marginBottom:5}}/>
                    <View style={{paddingLeft:20}}>
                    {
                        props.typeList.map((text)=>{
                            const convert = deviceTypeCode.filter(c=>c.key === text)[0];
                            return convert ? <CheckBoxAndText key={text} text={text} convertText={convert.value} list={filterType} setFilter={setFilterType}/> : null
                        })
                    }
                    </View>
                </View>} */}

                {/* 데이터센터 (DataCenter) */}
                {/* <Pressable style={{flexDirection:"row", alignItems:"center", marginBottom:10, marginTop:24}} onPress={()=>setDataCenterExpand(!dataCenterExpand)}>
                    <View style={{transform: [{ rotate: typeExpand ? '0deg' : '180deg' }] }}><ArrowIco /></View>
                    <Text style={{color:"#333333", fontSize:14, fontFamily:FONT.MEDIUM, marginLeft:10}}>{String.RMS_DEVICE_DETAIL_DATACENTER}</Text>
                </Pressable>
                {dataCenterExpand && <View style={{width:220, backgroundColor:"#fafafa", padding:16, borderRadius:10}}>
                    <AllCheckBoxAndText filter={filterDataCenter} list={props.dataCenterList} setFilter={setFilterDataCenter}/>
                    <View style={{backgroundColor:"#eceeef", height:1, marginBottom:5}}/>
                    <View style={{paddingLeft:20}}>
                    {
                        props.dataCenterList.map((text)=>{
                            return <CheckBoxAndText key={text} text={text} convertText={text} list={filterDataCenter} setFilter={setFilterDataCenter}/>
                        })
                    }
                    </View>
                </View>} */}
            </ScrollView>
        </View>
    )
}